// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-wrapper {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.welcome-outer-box:hover {
	filter: drop-shadow(5px 5px 5px var(--neutral-color1));
}
.welcome-outer-box h3 {
	font-size: 1.8rem;
	cursor: pointer;
}
.welcome-wrapper h1 {
	font-size: 2.5rem;
	margin: 5rem;
}
.logout {
	 position: absolute;
	right: 0;
	top: 0; 
	/* width: 300px; */
	height: 40px;
	border: none;
	color: white;
	margin: 1rem;
	font-size: 1.4rem;
	cursor: pointer;
	align-self: flex-end;
}
.logo-div {
	position: absolute;
	width: 200px;
	height: 200px;
	left: 6px;
	top: 5px;
	margin-bottom: 20px;
}
.welcome-outer-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative; /* Ensure it's positioned to contain absolutely positioned children */
	overflow: hidden; /* To ensure the pseudo-element's animation is contained */
	width: 100%;
	padding: 1rem;
	margin: 0.5rem 0.5rem;
	border-radius: 5px;
	filter: drop-shadow(0 0 10px var(--neutral-color1));
}

.small-button {
	width: 100px;
	height: 30px;
	border: none;
	border-radius: 5px;
	background-color: var(--primary-color1);
	color: white;
	font-size: 1rem;
	cursor: pointer;
	text-align: center;
	padding: 1rem;
}

.welcome-outer-box p {
	/* font-size: 1.6rem; */
	/* margin: 1rem; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApiWelcomePage/ApiWelcomePage.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,sDAAsD;AACvD;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,YAAY;AACb;AACA;EACE,kBAAkB;CACnB,QAAQ;CACR,MAAM;CACN,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,SAAS;CACT,QAAQ;CACR,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB,EAAE,qEAAqE;CACzF,gBAAgB,EAAE,0DAA0D;CAC5E,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,kBAAkB;CAClB,mDAAmD;AACpD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,uCAAuC;CACvC,YAAY;CACZ,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;AACnB","sourcesContent":[".welcome-wrapper {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n}\n\n.welcome-outer-box:hover {\n\tfilter: drop-shadow(5px 5px 5px var(--neutral-color1));\n}\n.welcome-outer-box h3 {\n\tfont-size: 1.8rem;\n\tcursor: pointer;\n}\n.welcome-wrapper h1 {\n\tfont-size: 2.5rem;\n\tmargin: 5rem;\n}\n.logout {\n\t position: absolute;\n\tright: 0;\n\ttop: 0; \n\t/* width: 300px; */\n\theight: 40px;\n\tborder: none;\n\tcolor: white;\n\tmargin: 1rem;\n\tfont-size: 1.4rem;\n\tcursor: pointer;\n\talign-self: flex-end;\n}\n.logo-div {\n\tposition: absolute;\n\twidth: 200px;\n\theight: 200px;\n\tleft: 6px;\n\ttop: 5px;\n\tmargin-bottom: 20px;\n}\n.welcome-outer-box {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tposition: relative; /* Ensure it's positioned to contain absolutely positioned children */\n\toverflow: hidden; /* To ensure the pseudo-element's animation is contained */\n\twidth: 100%;\n\tpadding: 1rem;\n\tmargin: 0.5rem 0.5rem;\n\tborder-radius: 5px;\n\tfilter: drop-shadow(0 0 10px var(--neutral-color1));\n}\n\n.small-button {\n\twidth: 100px;\n\theight: 30px;\n\tborder: none;\n\tborder-radius: 5px;\n\tbackground-color: var(--primary-color1);\n\tcolor: white;\n\tfont-size: 1rem;\n\tcursor: pointer;\n\ttext-align: center;\n\tpadding: 1rem;\n}\n\n.welcome-outer-box p {\n\t/* font-size: 1.6rem; */\n\t/* margin: 1rem; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
